module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-md-3 row"
  }, [_c('div', {
    staticClass: "pricing-table"
  }, [_c('h3', {
    staticClass: "pricing-title"
  }, [_vm._v("Básico")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("Gratis")]), _vm._v(" "), _c('ul', {
    staticClass: "table-list"
  }, [_c('li', [_vm._v("2 publicaciones "), _c('span', [_vm._v("grátis por mes")])]), _vm._v(" "), _c('li', [_vm._v("Visualización"), _c('span', [_vm._v(" simple  de CVs")])]), _vm._v(" "), _c('li', [_vm._v("Hasta 14 días "), _c('span', [_vm._v("visible")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Ver detalle\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 row"
  }, [_c('div', {
    staticClass: "pricing-table recommended"
  }, [_c('h3', {
    staticClass: "pricing-title"
  }, [_vm._v("Plata (*)")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("$11.990"), _c('sup', [_vm._v("+ IVA / mes")])]), _vm._v(" "), _c('ul', {
    staticClass: "table-list"
  }, [_c('li', [_vm._v("7 publicaciones "), _c('span', [_vm._v("por mes")])]), _vm._v(" "), _c('li', [_vm._v("4 publicaciones "), _c('span', [_vm._v("destacadas")])]), _vm._v(" "), _c('li', [_vm._v("Visualización y descarga"), _c('span', [_vm._v("  de CVs")])]), _vm._v(" "), _c('li', [_vm._v("Hasta 20 días "), _c('span', [_vm._v("visible")])]), _vm._v(" "), _c('li', [_vm._v("Ver video"), _c('span', [_vm._v(" presentaciones de postulantes")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Ver detalle\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "table-buy"
  }, [_c('a', {
    staticClass: "pricing-action",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comprar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 row"
  }, [_c('div', {
    staticClass: "pricing-table"
  }, [_c('h3', {
    staticClass: "pricing-title"
  }, [_vm._v("Oro (*)")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("$35.990"), _c('sup', [_vm._v("+ IVA / mes ")])]), _vm._v(" "), _c('ul', {
    staticClass: "table-list"
  }, [_c('li', [_vm._v("15 publicaciones "), _c('span', [_vm._v("por mes")])]), _vm._v(" "), _c('li', [_vm._v("8 publicaciones "), _c('span', [_vm._v("destacadas")])]), _vm._v(" "), _c('li', [_vm._v("Visualización y descarga"), _c('span', [_vm._v("  de CVs")])]), _vm._v(" "), _c('li', [_vm._v("Hasta 30 días "), _c('span', [_vm._v("visible")])]), _vm._v(" "), _c('li', [_vm._v("Ver video"), _c('span', [_vm._v(" presentaciones de postulantes")])]), _vm._v(" "), _c('li', [_vm._v("Realizar video entrevistas"), _c('span', [_vm._v(" (muchos participantes)")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Ver detalle\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "table-buy"
  }, [_c('a', {
    staticClass: "pricing-action",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comprar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 row"
  }, [_c('div', {
    staticClass: "pricing-table"
  }, [_c('h3', {
    staticClass: "pricing-title"
  }, [_vm._v("Oro Plus(*)")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("$45.990"), _c('sup', [_vm._v("+ IVA / mes ")])]), _vm._v(" "), _c('ul', {
    staticClass: "table-list"
  }, [_c('li', [_vm._v("Publicaciones Indefinidas")]), _vm._v(" "), _c('li', [_vm._v("16 publicaciones "), _c('span', [_vm._v("destacadas")])]), _vm._v(" "), _c('li', [_vm._v("Visualización y descarga"), _c('span', [_vm._v("  de CVs")])]), _vm._v(" "), _c('li', [_vm._v("Hasta 45 días "), _c('span', [_vm._v("visible")])]), _vm._v(" "), _c('li', [_vm._v("Ver video"), _c('span', [_vm._v(" presentaciones de postulantes")])]), _vm._v(" "), _c('li', [_vm._v("Realizar video entrevistas"), _c('span', [_vm._v(" (muchos participantes)")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                Ver detalle\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "table-buy"
  }, [_c('a', {
    staticClass: "pricing-action",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Comprar")])])])]), _vm._v(" "), _c('div', [_vm._v("\n        (*) Flexibilidad para cambios de planes y cancelación de servicio.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb4482a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/planes/planes.vue
// module id = 667
// module chunks = 1